export const QINGO_PAYMENT_TYPE = 3
export const RECEIVE_TYPE = 2

export const ENTITY_TYPE_OPTIONS = [
  { label: 'Individual', value: 0 },
  { label: 'Sole Prop.', value: 1 },
  { label: 'Company', value: 2 },
]

export function initFormData() {
  return {
    mct_type: 0,
    mct_id: '',
    business_info_dto: {
      company_name: '',
      company_address: '',
      company_city: '',
      company_state: '',
      company_zip: '',
    },
    principals_dto: {
      principal_name: '',
      state: '',
      city: '',
      home_address: '',
    },
    business_profile_and_assumptions_dto: {},
    bank_info_dto: {
      bank_routing_num: '',
      bank_account: '',
      bank_name: '',
      recipient_name: '',
      nick_name: '',
      state: '',
      city: '',
      address: '',
      postal_code: '',
    },
  }
}

const input = (path, label, extra = {}) => ({ path, label, type: 'input', required: true, ...extra })

export function buildSections() {
  return [
    {
      id: 'entity', title: 'Entity Information', icon: '/static/ai/application/legal-icon.svg',
      fields: [{ path: 'mct_type', label: 'Entity Type', type: 'entityType', required: true }],
    },
    {
      id: 'corporate', title: 'Information', icon: '/static/ai/application/legal-icon.svg',
      showIf: (form) => form.mct_type !== 0,
      fields: [
        input('business_info_dto.company_name', 'Corporate/Legal Name'),
        { path: 'business_info_dto.company_state', label: 'Corporate Address-State', type: 'regionState', required: true },
        input('business_info_dto.company_city', 'Corporate Address-City'),
        input('business_info_dto.company_address', 'Corporate Address'),
        input('business_info_dto.company_zip', 'Corporate-Zip Code', { validate: 'zip' }),
      ],
    },
    {
      id: 'principal', title: 'Legal Representative Information', icon: '/static/ai/application/owner-icon.svg',
      fields: [
        input('principals_dto.principal_name', 'Principal Name'),
        { path: 'principals_dto.state', label: 'Home Address-State', type: 'regionState', required: true },
        input('principals_dto.city', 'Home Address-City'),
        input('principals_dto.home_address', 'Address'),
      ],
    },
    {
      id: 'bank', title: 'Settlement Account Information', icon: '/static/ai/application/bank-icon.svg',
      fields: [
        input('bank_info_dto.bank_routing_num', 'ABA (Routing)', { inputType: 'number', validate: 'routing' }),
        input('bank_info_dto.bank_account', 'DDA(Account #)', { validate: 'bankAccount' }),
        input('bank_info_dto.bank_name', 'Bank Name', { validate: 'bankName' }),
        input('bank_info_dto.recipient_name', 'Recipient Name', { validate: 'name' }),
        input('bank_info_dto.nick_name', 'Account Nickname'),
        { path: 'bank_info_dto.state', label: 'State', type: 'regionState', required: true },
        input('bank_info_dto.city', 'City'),
        input('bank_info_dto.address', 'Address'),
        input('bank_info_dto.postal_code', 'Postal Code', { validate: 'zip' }),
      ],
    },
  ].map((section) => ({ ...section, fieldCount: section.fields.length }))
}
